import {createContext, Dispatch, SetStateAction} from "react"
import {Keys} from "../interfaces/keys"
import {ProfileDB} from "../models/ProfileDB.model"
import {AuthMethod} from "../types"

interface AuthContextInterface {
  authMethod?: AuthMethod
  keys?: Keys | null
}

export const AuthContext = createContext<AuthContextInterface>({})
